import { useState } from 'react';
import { getPrimaryTracker } from 'usage-tracker-container';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import Products from 'merchandise-lib/constants/Product';
import useCreditsPageNavItemTabs from '../../../hooks/useCreditsPageTabNavItems';
import { getProductLineForNavItem } from '../../../utils/routingUtils';
import { trackButtonClick } from '../../../v2/utils/tracking/trackingEventUtils';
import NavItemTabs from '../../../components/hubspot-credits/NavItemTabs';
import { useProductDetails } from '../../../v2/hooks/product/useProductDetails';
import { SingleSkeletonLoader } from '../SingleSkeletonLoader';
import { withErrorBoundary } from '../error-boundary/withErrorBoundary';
import { CustomError } from '../error-boundary/CustomErrors';
import { SCREENS } from '../../constants/tracking/Screens';
import { UnlockAIContentLayout } from './UnlockAIContentLayout';
import { BillingNameTitle } from './BillingNameTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const billingNameKeyMap = {
  MARKETING: Products.MARKETING_HUB_STARTER,
  SALES: Products.SALES_HUB_STARTER,
  SERVICE: Products.SERVICE_HUB_STARTER,
  CMS: Products.CMS_HUB_STARTER,
  OPERATIONS: Products.OPERATIONS_HUB_STARTER,
  COMMERCE: Products.COMMERCE_HUB_PROFESSIONAL
};
const UnlockAIContentTabLayoutBase = () => {
  var _billingNameKeyMap$pr;
  const {
    tabs,
    loading: tabsLoading,
    error: tabsError
  } = useCreditsPageNavItemTabs();
  const [subscreen, setSubscreen] = useState(tabs[0]);
  const productLine = getProductLineForNavItem(subscreen);
  const billingNameKey = subscreen === SCREENS.SUITE || !productLine ? 'crm-suite-starter-bundle' : (_billingNameKeyMap$pr = billingNameKeyMap[productLine]) !== null && _billingNameKeyMap$pr !== void 0 ? _billingNameKeyMap$pr : 'crm-suite-starter-bundle';
  const {
    productDetails,
    loading: productDetailsLoading,
    error: productDetailsError
  } = useProductDetails({
    productApiName: billingNameKey
  });
  const skuIds = productDetails !== null && productDetails !== void 0 && productDetails.skuId ? [productDetails.skuId] : [];
  const title = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "pricingPage.pages.hubspot-credits.unlockAI.title.withBillingName",
    options: {
      billingName: billingNameKey ? /*#__PURE__*/_jsx(BillingNameTitle, {
        billingNameKey: billingNameKey
      }) : null
    }
  });
  if (productDetailsError) {
    throw new CustomError('Failed getting product details', {
      error: productDetailsError
    });
  }
  if (tabsError) {
    throw new CustomError('Failed getting tabs', {
      error: tabsError
    });
  }
  if (tabsLoading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 1000,
      width: "100%"
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(NavItemTabs, {
      selected: subscreen,
      setSelected: tab => {
        trackButtonClick({
          action: 'click nav item tab',
          value: tab,
          tab
        });
        getPrimaryTracker().setProperties({
          subscreen: tab
        });
        setSubscreen(tab);
      },
      tabs: tabs
    }), productDetailsLoading ? /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 1000,
      width: "100%"
    }) : /*#__PURE__*/_jsx(UnlockAIContentLayout, {
      subscreen: subscreen,
      unlockHubSpotCreditsSkuIds: skuIds,
      title: title
    })]
  });
};
export const UnlockAIContentTabLayout = withErrorBoundary(UnlockAIContentTabLayoutBase, {
  fallback: null,
  errorBoundaryName: 'UnlockAIContentTabLayout'
});